module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm()
      }
    }
  }, [_c('div', [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "80",
      "desktop": "50",
      "tablet": "70"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-time-picker', {
    attrs: {
      "label": _vm.$t('message.labelTime'),
      "mode": "portrait",
      "fullWidth": "",
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText')
    },
    model: {
      value: (_vm.timeModel.time),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "time", $$v)
      },
      expression: "timeModel.time"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "label": _vm.$t('message.labelDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.timeModel.date),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "date", $$v)
      },
      expression: "timeModel.date"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', {
    staticStyle: {
      "margin-bottom": "8px"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.reading.treatment_name) + "\n          ")])], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max_value:2500'),
      expression: "'required|max_value:2500'"
    }],
    attrs: {
      "data-vv-name": "dosage",
      "errorText": _vm.errors.first('dosage'),
      "hintText": _vm.$t('message.labelDosage'),
      "label": _vm.$t('message.labelDosage'),
      "helpText": _vm.localizeRegime(_vm.reading.unit_label),
      "fullWidth": ""
    },
    model: {
      value: (_vm.reading.dosage),
      callback: function($$v) {
        _vm.$set(_vm.reading, "dosage", $$v)
      },
      expression: "reading.dosage"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-flat-button', {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeEditMode(_vm.reading)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "disabled": _vm.isUpdating,
      "label": _vm.isUpdating ? _vm.$t('message.updatingText') : _vm.$t('message.updateText'),
      "type": "button",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-452eddcc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/Edit/Medication/MedicationEdit.vue
// module id = 3700
// module chunks = 1